import { render, staticRenderFns } from "./DunningOverall.vue?vue&type=template&id=866dc0a6&"
import script from "./DunningOverall.vue?vue&type=script&lang=ts&"
export * from "./DunningOverall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports